import { Component, OnInit } from '@angular/core';
import { AuthService } from '@drl/core/auth/auth.service';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-active-session-dialog',
  templateUrl: './active-session-dialog.component.html',
  styleUrls: ['./active-session-dialog.component.scss']
})
export class ActiveSessionDialogComponent implements OnInit {

  constructor(
    protected dialogRef: NbDialogRef<ActiveSessionDialogComponent>,
    private readonly authService: AuthService,
  ) { }


  username: string;
  password: string;
  tenantName: string;
  loading: boolean;
  
  ngOnInit() {
  }
  
  continueSession(){
    this.loading = true;
    this.authService.login(this.username, this.password, this.tenantName, true).subscribe(
      response => {
        if (response.body) {
          this.authService.authorize(response.body);
          this.closeModal();
        }
      },
      error => {
        this.closeModal();
      }
    );
  }

  closeModal(){
    this.loading = false;
    this.dialogRef.close();
  }
}
